 

import { useEffect, useRef } from "react"
import CharacterBlock from "./CharacterBlock"
import "../styles/Visualizer.css"

function Visualizer({ text, pattern, currentStep, isPlaying, speed, onStepComplete }) {
  const timerRef = useRef(null)

  useEffect(() => {
    if (isPlaying && currentStep) {
      timerRef.current = setTimeout(() => {
        onStepComplete()
      }, 2000 / speed)
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
    }
  }, [isPlaying, currentStep, speed, onStepComplete])

  const getPatternPosition = () => {
    if (!currentStep) return 0

    if (currentStep.type === "position" || currentStep.type === "compare" || currentStep.type === "match") {
      return currentStep.textPos
    }

    if (currentStep.type === "shift") {
      return currentStep.textPos + currentStep.shift
    }

    return 0
  }

  const getComparisonState = (textIndex) => {
    if (!currentStep || currentStep.type !== "compare") return "normal"

    const patternIndex = textIndex - currentStep.textPos

    if (patternIndex === currentStep.patternPos) {
      return currentStep.match ? "match" : "mismatch"
    }

    if (patternIndex > currentStep.patternPos && patternIndex < pattern.length) {
      return "match"
    }

    return "normal"
  }

  const renderShiftArrow = () => {
    if (!currentStep || currentStep.type !== "shift") return null

    const startPos = currentStep.textPos
    const endPos = currentStep.textPos + currentStep.shift

    return (
      <div className="shift-arrow" style={{ left: `${startPos * 40 + 20}px`, width: `${(endPos - startPos) * 40}px` }}>
        <div className="arrow-line"></div>
        <div className="arrow-head"></div>
        <div className="shift-label">
          <span>Shift: {currentStep.shift}</span>
          <div className="shift-details">
            <div>Bad Char: {currentStep.badCharShift}</div>
            <div>Good Suffix: {currentStep.goodSuffixShift}</div>
          </div>
        </div>
      </div>
    )
  }

  if (!text || !pattern) {
    return (
      <div className="bmvisualizer">
        <div className="empty-state">
          <p>
            Please enter text and pattern in the input fields above, then click "Run Algorithm" to start the
            visualization.
          </p>
        </div>
      </div>
    )
  }

  const patternPosition = getPatternPosition()

  return (
    <div className="bmvisualizer">
      <div className="text-container">
        <div className="text-label">Text:</div>
        <div className="text-blocks">
          {text.split("").map((char, index) => (
            <CharacterBlock key={index} char={char} state={getComparisonState(index)} />
          ))}
        </div>
      </div>

      <div className="pattern-container" style={{ left: `${patternPosition * 40}px` }}>
        <div className="pattern-label">Pattern:</div>
        <div className="pattern-blocks">
          {pattern.split("").map((char, index) => (
            <CharacterBlock
              key={index}
              char={char}
              state={
                currentStep && currentStep.type === "compare" && index === currentStep.patternPos
                  ? currentStep.match
                    ? "match"
                    : "mismatch"
                  : "normal"
              }
            />
          ))}
        </div>
      </div>

      {renderShiftArrow()}

      <div className="current-step-info">
        {currentStep && (
          <>
            <div className="step-description">{currentStep.description}</div>
            <div className="step-explanation">{currentStep.explanation}</div>
          </>
        )}
      </div>
    </div>
  )
}

export default Visualizer

